import { QubictronUrlBuilder } from "@qubictron/url/client";
import axios from "axios";
import { DateTimeModel } from "entities/shared/shipmentCard.types";
import { injectAuthHeader, injectDataInterceptor, injectSearchCustomHeader } from "shared/api/utils/api.utils";

const CHECK_API_PROFILE_ACCESS_API_URL = new QubictronUrlBuilder()
  .appendPathname("tracking-system/check-profile-air")
  .build();

const checkApiProfileAccessRequestInstance = axios.create();
checkApiProfileAccessRequestInstance.defaults.baseURL = CHECK_API_PROFILE_ACCESS_API_URL;
injectDataInterceptor(checkApiProfileAccessRequestInstance);
injectSearchCustomHeader(checkApiProfileAccessRequestInstance);
injectAuthHeader(checkApiProfileAccessRequestInstance);

enum CheckApiProfileAccessStatusCode {
  "OK" = "OK",
  "UNEXPECTED_ERROR" = "UNEXPECTED_ERROR",
}

export type CheckApiProfileAccessResponseModel = {
  status_code: CheckApiProfileAccessStatusCode;
  data: {
    api_calls: {
      used: number | null;
      total: number | null;
      remaining: number | null;
    };
    unique_shipments?: {
      used: number | null;
      total: number | null;
      remaining: number | null;
    };
    is_free?: boolean;
    subscription?: {
      unique_shipments: {
        used: number | null;
        total: number | null;
        remaining: number | null;
      };
      start_date: DateTimeModel;
      end_date: DateTimeModel;
    };
    daily?: {
      unique_shipments?: {
        total: number | null;
        used: number | null;
        remaining: number | null;
      };
    };
  };
};

// const mockPaidSubscription = {
//   api_calls: {
//     used: 10,
//     total: 20,
//     remaining: 10,
//   },
//   unique_shipments: {
//     used: 10,
//     total: 20,
//     remaining: 10,
//   },
//   is_free: false,
//   subscription: {
//     unique_shipments: {
//       total: 20,
//       used: 10,
//       remaining: 10,
//     },
//     start_date: "2025-04-15",
//     end_date: "2025-05-15",
//   },
// };

// const mockFreeSubscription = {
//   api_calls: {
//     used: 10,
//     total: 20,
//     remaining: 10,
//   },
//   unique_shipments: {
//     used: 10,
//     total: 20,
//     remaining: 10,
//   },
//   is_free: true,
//   daily: {
//     unique_shipments: {
//       total: 3,
//       used: 3,
//       remaining: 0,
//     },
//   },
// };

class ApiProfileAccessService {
  public checkProfileAccess(): Promise<CheckApiProfileAccessResponseModel> {
    return checkApiProfileAccessRequestInstance.get("");
    // return new Promise<CheckApiProfileAccessResponseModel>((resolve) => {
    //   setTimeout(() => {
    //     resolve({
    //       status_code: CheckApiProfileAccessStatusCode.OK,
    //       data: mockPaidSubscription,
    //     });
    //   }, 100);
    // });
  }
}

const apiProfileAccessService = new ApiProfileAccessService();

export { apiProfileAccessService };
